import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Button } from '@mui/material';

import { HeaderAction } from '@app/components/ListHeaderActions';

interface CopyButtonProps {
  action: HeaderAction;
}

export const CopyButton = ({ action }: CopyButtonProps) => {
  return (
    <Button
      data-cy="copy"
      variant="outlined"
      disabled={action.disabled}
      color="primary"
      sx={{ marginLeft: 2 }}
      startIcon={<ContentCopyIcon />}
      onClick={action.handler}>
      {action.label ?? 'COPY SCHEDULE'}
    </Button>
  );
};
